import React, { useCallback, useState } from 'react';
import { Text } from 'view/atoms/Text';
import { IPaginationItemProps } from './PaginationItem.model';
import * as S from './PaginationItem.styles';

export const PaginationItem = ({
  index,
  active = false,
  changeCurrentPage,
}: IPaginationItemProps) => {
  const handleClick = useCallback(() => {
    changeCurrentPage(index);
  }, [index]);

  const [isTouchStart, setIsTouchStart] = useState(false);
  const handleToggle = () => setIsTouchStart((prev) => !prev);

  return (
    <S.PaginationItem
      active={active}
      onClick={handleClick}
      isTouchStart={isTouchStart}
      onTouchStart={handleToggle}
      onTouchEnd={handleToggle}
    >
      <Text kind='button' color={active ? 'gray1' : 'gray2'}>
        {index}
      </Text>
    </S.PaginationItem>
  );
};
